export default "__VITE_ASSET__B0FpLUTn__"